// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"m7-z"};